export const EMPTY_STATE_COLSPAN_REBATES = 5;
export const EMPTY_STATE_COLSPAN_DETAILS = 8;
export const EMPTY_STATE_COLSPAN_OVERVIEW = 5;

export const REBATE_STATEMENTS_PER_PAGE = 10;
